import React from "react";
import { BRAND, NAV_LINKS } from "@/lib/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="surface-band border-t border-[#ebebeb] py-10 sm:py-16"
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-8 md:gap-10">
          <div className="sm:col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="Innovate IT Solutions"
                className="h-7 w-7 sm:h-8 sm:w-8 object-contain rounded-[4px]"
              />
              <span className="text-[17px] sm:text-[18px] font-medium text-[#222222] tracking-tight">
                Innovate<span className="text-[#6a6a6a]">.it</span>
              </span>
            </div>
            <p className="mt-3 sm:mt-4 max-w-sm text-[13px] sm:text-[14px] text-[#6a6a6a] leading-relaxed">
              Software studio and industry academy in Pune, India. Crafting production-grade
              systems and preparing world-class engineering talent.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[12px] sm:text-[13px] font-medium text-[#222222] uppercase tracking-wider">
              Navigation
            </p>
            <ul className="mt-3 sm:mt-4 space-y-2 sm:space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[13px] sm:text-[14px] text-[#6a6a6a] hover:text-[#222222] transition-colors rounded-[4px]"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[12px] sm:text-[13px] font-medium text-[#222222] uppercase tracking-wider">
              Studio
            </p>
            <p className="mt-3 sm:mt-4 text-[13px] sm:text-[14px] text-[#6a6a6a] leading-relaxed">
              {BRAND.contact.address}
            </p>
            <p className="mt-2 text-[13px] sm:text-[14px] text-[#6a6a6a]">
              {BRAND.contact.email} · {BRAND.contact.phone}
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-[#ebebeb] flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] sm:text-[13px] text-[#6a6a6a]">
          <p>© {year} Innovate IT Solutions. All rights reserved.</p>
          <p>Pune, Maharashtra, India</p>
        </div>
      </div>
    </footer>
  );
};
